import React, { useState } from "react";
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button'
import DialogContent from '@mui/material/DialogContent'
import { BootstrapDialog, BootstrapDialogTitle } from 'common/AbstractModal/BootstrapDialog'

import AddCatalogToPage from './AddCatalogToPage';

export interface ManagePageAddCatalogProps {
    id: string
}

export default function ManagePageAddCatalog({
    id
}: ManagePageAddCatalogProps) {
    const [open, setOpen] = useState(false)
    const handleClickOpen = () => {
        setOpen(true)
    }
    const handleClose = () => {
        setOpen(false)
    }

    //handle form submit api here
    return (
        <div>
            <Button variant='filled' size='small' onClick={handleClickOpen}>
                <AddIcon />
            </Button>
            <BootstrapDialog
                fullWidth
                maxWidth='lg'
                onClose={handleClose}
                aria-labelledby='customized-dialog-title'
                open={open}
            >
                <BootstrapDialogTitle onClose={handleClose}>
                    Manage Page Catalogs
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <AddCatalogToPage pageId={id} handleClose={handleClose} />
                </DialogContent>
            </BootstrapDialog>
        </div>
    )
}
